import { h } from 'preact';
import { useMemo } from 'preact/hooks';
import { useNewStore, usePlayerContext, useStyles } from '../../../common/hooks';
import { withBreakPoints } from '../../hoc';

import SeekBackground from '../../../common/components/wrappers/SeekBackground';
import { SUBTITLE_LAYER } from '../../../common/constants';
import { MAIN_GRADIENT, MAIN_GRADIENT_AD } from '../../theme/colors';
import { AdInfos, StartScreen } from '../info';
import SectionBottom from './SectionBottom';
import SectionOverlay from './SectionOverlay';
import SectionTop from './SectionTop';
import SubtitleContainer from './SubtitleContainer';
import Zap from './Zap';
import {
  MAIN_WRAPPER_PADDING,
  MAIN_WRAPPER_STYLE,
  UI_WRAPPER_STYLE
} from './styles';

function Main({
  UIVisible, handleTap, /* passed via InteractionHandler */
  mobile
}) {
  const player = usePlayerContext();
  const { canInteract, forceHidden, isSeeking, waitStart, width, height } = useNewStore('ui', player);
  const { isAd } = useNewStore('ad', player);
  const { isAudio, backgroundImageSquare } = useNewStore('media', player);
  const setStyles = useStyles();

  const WRAPPER_STYLE = useMemo(() => (isAudio
    ? {
      ...UI_WRAPPER_STYLE,
      backgroundImage: `url("${backgroundImageSquare}")`,
      backgroundSize: '40% auto',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      transform: 'scale(1.009)'
    }
    : UI_WRAPPER_STYLE), [backgroundImageSquare, isAudio]);

  const sectionWrapperStyles = useMemo(() => (
    {
      ...UI_WRAPPER_STYLE,
      ...(UIVisible || waitStart ? {} : { cursor: 'none' }),
      ...(isAd ? { cursor: 'pointer' } : {}),
      ...(isSeeking ? { backgroundColor: 'rgba(0, 0, 0, 0.6)' } : { backgroundColor: 'transparent' })
    }
  ), [UIVisible, isAd, isSeeking, waitStart]);

  return (
    <div style={UI_WRAPPER_STYLE}>
      <div style={WRAPPER_STYLE}>
        <SectionOverlay
          waitStart={waitStart}
          handleTap={handleTap}
          containerVisible={UIVisible}
        />
        <SeekBackground />
        <StartScreen isMounted={waitStart} />
        <AdInfos /* timeleft and info button for mobile */ />
        {
          !waitStart && !(mobile && forceHidden)
          && (
            <div
              className="ftv-magneto--overlay"
              style={{
                ...{
                  position: 'relative',
                  width: '100%',
                  height: '100%',
                  zIndex: SUBTITLE_LAYER - 1
                },
                backgroundImage: UIVisible ? ((isAd && MAIN_GRADIENT_AD) || MAIN_GRADIENT) : ''
              }}
            >
              <SubtitleContainer
                style={{
                  ...UI_WRAPPER_STYLE,
                  ...setStyles(MAIN_WRAPPER_PADDING),
                  position: 'absolute',
                  zIndex: SUBTITLE_LAYER
                }}
                sideMargin={1}
                width={width}
                height={height}
                show={!waitStart}
              />
              <div
                style={sectionWrapperStyles}
                role="presentation"
              >
                <div
                  className="ftv-magneto-main"
                  style={setStyles(MAIN_WRAPPER_STYLE)}
                >
                  <SectionTop />
                  <SectionBottom />
                  {(UIVisible && canInteract && !waitStart) && <Zap />}
                </div>
              </div>
            </div>
          )
        }
      </div>
      {/* For fullscreen modals */}
      <div id="ftv-magneto-modal-portal-container" />
    </div>
  );
}

export default withBreakPoints(Main);
